// AUTO-GENERATED FILE - DO NOT EDIT BY HAND
// Generated from registry-tool-specs.yaml by scripts/buildRegistryToolSpecs.ts

export interface RegistryToolSpec {
  toolId: string;
  displayName: string;
  description: string;
  typicalPhase: string;
  allowedScopes: string[];
  prerequisites: string[];
  /** Specific item-level field keys this tool requires (e.g. ["impact", "effort"]). */
  requiredItemFields: string[];
  compatibility: {
    family: string;
    minItems: number;
    maxItems?: number;
    requiresCriteria: boolean;
    toolDefinesCriteria?: boolean;
    supportedScaleTypes: string[];
    supportsWeights: boolean;
    minParticipants?: number;
  };
}

export const REGISTRY_TOOL_SPECS: RegistryToolSpec[] = [
  {
    "toolId": "rice",
    "displayName": "RICE",
    "description": "Scoring tool: Reach, Impact, Confidence, Effort.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "CRITERIA_LOCKED",
      "VALUES_SUFFICIENT"
    ],
    "requiredItemFields": [
      "reach",
      "impact",
      "confidence",
      "effort"
    ],
    "compatibility": {
      "family": "scoring",
      "minItems": 2,
      "requiresCriteria": true,
      "supportedScaleTypes": [
        "numeric",
        "ordinal",
        "likert"
      ],
      "supportsWeights": false,
      "toolDefinesCriteria": true
    }
  },
  {
    "toolId": "wsjf",
    "displayName": "WSJF",
    "description": "Scoring tool: Weighted Shortest Job First.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "CRITERIA_LOCKED",
      "VALUES_SUFFICIENT"
    ],
    "requiredItemFields": [
      "cost_of_delay",
      "job_duration"
    ],
    "compatibility": {
      "family": "scoring",
      "minItems": 2,
      "requiresCriteria": true,
      "supportedScaleTypes": [
        "numeric",
        "ordinal",
        "likert"
      ],
      "supportsWeights": true,
      "toolDefinesCriteria": true
    }
  },
  {
    "toolId": "cost_of_delay",
    "displayName": "Cost of Delay",
    "description": "Framework to estimate economic impact of delay; often used as an input to WSJF.",
    "typicalPhase": "GATHER",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "CRITERIA_LOCKED"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "scoring",
      "minItems": 1,
      "requiresCriteria": true,
      "supportedScaleTypes": [
        "numeric",
        "ordinal",
        "likert"
      ],
      "supportsWeights": false,
      "toolDefinesCriteria": true
    }
  },
  {
    "toolId": "simple_weighted_scoring",
    "displayName": "Simple Weighted Scoring",
    "description": "General-purpose weighted scoring across selected criteria.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "CRITERIA_LOCKED",
      "VALUES_SUFFICIENT"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "scoring",
      "minItems": 2,
      "requiresCriteria": true,
      "supportedScaleTypes": [
        "numeric",
        "ordinal",
        "likert"
      ],
      "supportsWeights": true
    }
  },
  {
    "toolId": "pareto_analysis",
    "displayName": "Pareto Analysis",
    "description": "Identifies the vital few contributors (80/20) based on an existing score or measure.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "VALUES_SUFFICIENT"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "scoring",
      "minItems": 2,
      "requiresCriteria": false,
      "supportedScaleTypes": [],
      "supportsWeights": false
    }
  },
  {
    "toolId": "moscow",
    "displayName": "MoSCoW",
    "description": "Categorization: Must / Should / Could / Won’t.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "scoring",
      "minItems": 1,
      "requiresCriteria": false,
      "supportedScaleTypes": [
        "categorical"
      ],
      "supportsWeights": false
    }
  },
  {
    "toolId": "impact_effort_matrix",
    "displayName": "Impact-Effort Matrix",
    "description": "2x2 placement (high/low impact vs high/low effort) for fast structuring.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "CRITERIA_LOCKED",
      "VALUES_SUFFICIENT"
    ],
    "requiredItemFields": [
      "impact",
      "effort"
    ],
    "compatibility": {
      "family": "matrix",
      "minItems": 2,
      "requiresCriteria": true,
      "supportedScaleTypes": [
        "numeric",
        "ordinal",
        "likert"
      ],
      "supportsWeights": false,
      "toolDefinesCriteria": true
    }
  },
  {
    "toolId": "max_priorities_pyramid",
    "displayName": "Max Priorities Pyramid",
    "description": "Structure-to-rank method that progressively narrows from many to a few priorities.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_LOCKED",
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "ranking",
      "minItems": 2,
      "requiresCriteria": false,
      "supportedScaleTypes": [],
      "supportsWeights": false
    }
  },
  {
    "toolId": "pairwise_ranking",
    "displayName": "Pairwise Ranking",
    "description": "Pairwise comparisons to derive an ordering.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_LOCKED",
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "pairwise",
      "minItems": 2,
      "requiresCriteria": false,
      "supportedScaleTypes": [],
      "supportsWeights": false,
      "maxItems": 15
    }
  },
  {
    "toolId": "dot_voting",
    "displayName": "Dot Voting",
    "description": "Voting-based signal; per-item votes aggregated into a score.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "voting",
      "minItems": 2,
      "requiresCriteria": false,
      "supportedScaleTypes": [],
      "supportsWeights": false,
      "minParticipants": 1
    }
  },
  {
    "toolId": "stack_ranking",
    "displayName": "Stack Ranking",
    "description": "Direct total ordering of items (often facilitator-driven, sometimes group-driven).",
    "typicalPhase": "PRIORITIZE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_LOCKED",
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "ranking",
      "minItems": 2,
      "requiresCriteria": false,
      "supportedScaleTypes": [],
      "supportsWeights": false
    }
  },
  {
    "toolId": "ahp",
    "displayName": "AHP",
    "description": "Analytic Hierarchy Process: pairwise comparisons derive criterion weights via eigenvector calculation, with consistency validation and weighted item scoring.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "scoring",
      "minItems": 2,
      "requiresCriteria": false,
      "supportedScaleTypes": [
        "numeric",
        "ordinal"
      ],
      "supportsWeights": true
    }
  },
  {
    "toolId": "fast_vs_right",
    "displayName": "Fast vs Right Framework",
    "description": "Decision guidance framework that classifies a decision into quadrants based on urgency and correctness requirements. Guides approach rather than scoring items.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [],
    "requiredItemFields": [],
    "compatibility": {
      "family": "framework",
      "minItems": 1,
      "requiresCriteria": false,
      "supportedScaleTypes": [
        "categorical"
      ],
      "supportsWeights": false
    }
  },
  {
    "toolId": "eisenhower_matrix",
    "displayName": "Eisenhower Matrix",
    "description": "2x2 categorization matrix classifying items by urgency and importance into quadrants: Do (urgent + important), Schedule (important, not urgent), Delegate (urgent, not important), Eliminate (neither).",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "matrix",
      "minItems": 1,
      "requiresCriteria": false,
      "supportedScaleTypes": [
        "categorical"
      ],
      "supportsWeights": false
    }
  },
  {
    "toolId": "speed_boat",
    "displayName": "Speed Boat",
    "description": "Collaborative retrospective: items classified as engines (driving forward), anchors (holding back), rocks (risks), or life preservers (mitigations), then ranked within each category.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "framework",
      "minItems": 1,
      "requiresCriteria": false,
      "supportedScaleTypes": [
        "categorical"
      ],
      "supportsWeights": false
    }
  },
  {
    "toolId": "prune_product_tree",
    "displayName": "Prune the Product Tree",
    "description": "Feature pruning exercise: items (branches) rated on value, impact, and feasibility (1-5), then marked active or pruned. Active branches ranked by composite score = (value + impact + feasibility) / 3.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "scoring",
      "minItems": 1,
      "requiresCriteria": false,
      "supportedScaleTypes": [
        "numeric"
      ],
      "supportsWeights": false
    }
  },
  {
    "toolId": "magic_prioritization",
    "displayName": "Magic Prioritization Trick",
    "description": "Staged decoupling that separates urgency, value, and duration judgments to surface qualitative Cost of Delay (CD3). Based on John Cutler and Joshua Arnold's qualitative CoD framework.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [],
    "compatibility": {
      "family": "scoring",
      "minItems": 2,
      "requiresCriteria": false,
      "supportedScaleTypes": [
        "ordinal"
      ],
      "supportsWeights": false
    }
  },
  {
    "toolId": "buy_a_feature",
    "displayName": "Buy-a-Feature",
    "description": "Budget allocation game; budgets spent become per-item scores.",
    "typicalPhase": "ARRANGE",
    "allowedScopes": [
      "cycle",
      "session"
    ],
    "prerequisites": [
      "POOL_NONEMPTY"
    ],
    "requiredItemFields": [
      "price"
    ],
    "compatibility": {
      "family": "voting",
      "minItems": 2,
      "requiresCriteria": false,
      "supportedScaleTypes": [],
      "supportsWeights": false,
      "minParticipants": 2
    }
  }
];

export const REGISTRY_TOOL_SPECS_BY_ID: Record<string, RegistryToolSpec> = Object.fromEntries(
  REGISTRY_TOOL_SPECS.map((spec) => [spec.toolId, spec])
);

export const REGISTRY_SESSION_TOOL_IDS = REGISTRY_TOOL_SPECS
  .filter((spec) => spec.allowedScopes.includes('session'))
  .map((spec) => spec.toolId);
